import { IParamsVO } from 'tag/ts/tag/interfaces/params/IParamsVO';
import { EmbedDevice } from 'tag/ts/tag/model/type/embed/EmbedDevice';
import { AbstractSTVPlatformConfig } from 'tag/ts/tag/player/stv/configs/platforms/AbstractSTVPlatformConfig';

export class LGWebOSConfigs extends AbstractSTVPlatformConfig {

	constructor( params: IParamsVO ) {
		super( params );
		this.configs = this.utils.DeepMerge.deepmerge( this.configs, {
			properties: {
				device: EmbedDevice.LG_WEB_OS
			},
			resourceConfig: {
				playback: {
					streaming: {
						stallEnabled: true,
						stallSkip: 1.2,
						stallThreshold: 2,
						jumpLargeGaps: true
					}
				}
			}
		} );
	}

}